<template>
  <div id="normalUserCenterRoot" :style="{ 'width': rootWidth, 'height': rootHeight }">
    <div id="normalUserCenterContainer">
      <div id="normalUserCenterTopContent"
        :style="{ 'background': '-webkit-linear-gradient(top, ' + $store.state.baseColor + ',' + $store.state.baseColor + ',#FBE9E7)' }">
        <div id="normalUserCenterTitleDiv">用户中心
          <img style="width:20px;height:20px;position:absolute;right:15px" src="~assets/img/normal/close_white.png"
            @click="pageClose()" />
        </div>
        <div style="width:20%;height:2px;border-bottom:2px solid white;"></div>
        <div style="background-color:white;height:2px;width:94%;"></div>

        <div id="normalTopMiddleDiv">
          <img style="width:50px;height:50px;position:absolute;left:15px" src="~assets/img/normal/center_logo.png" />
          <div id="normalTopAccountInfoDiv">
            <div id="normalAccount"
              :style="{ 'background-color': $store.state.baseSecondColor, 'font-size': $store.state.inputFontSize }">
              账号：{{ $store.state.commonParameters['username'] }}</div>
            <div id="normalRid" @click="userCenterRidClick()"
              :style="{ 'background-color': $store.state.baseSecondColor, 'font-size': $store.state.inputFontSize }">
              编号：{{ $store.state.rid }}</div>
          </div>
          <img style="width:32px;height:40px;position:absolute;right:15px" src="~assets/img/normal/service.png"
            @click="clickService()" />
        </div>
      </div>

      <div id="normalFeatureDiv">
        <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
          <img style="width:36px;height:50px;" src="~assets/img/normal/realname.png" @click="clickRealName()" />
        </div>
        <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
          <img style="width:36px;height:50px;" src="~assets/img/normal/account_safe.png" @click="clickAccountSafe()" />
        </div>
        <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
          <img style="width:36px;height:50px;" src="~assets/img/normal/change_pwd.png" @click="clickChangePsw()" />
        </div>
        <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
          <img style="width:36px;height:50px;" src="~assets/img/normal/switch_account.png"
            @click="clickSwitchAccount()" />
        </div>
      </div>
      <div id="normalBottomContent">
        <div id="normalFeatureContent">
          <KeepAlive>
            <router-view></router-view>
          </KeepAlive>
        </div>
        <div id="normalProtocolAndPolicyDiv">
          <div
            style="position: absolute;right: 0;width: auto;height:100%;display: flex;flex-direction: row;justify-content: center;align-items: center;">
            <span @click="protocolClick()" :style="{ 'color': $store.state.baseColor }"
              style="font-size: x-small;">《注册协议》</span>
            <span @click="privicyClick()" :style="{ 'color': $store.state.baseColor }"
              style="font-size: x-small;">《隐私政策》</span>
          </div>
        </div>
      </div>
    </div>
    <SwitchAccountDialog v-if="showSwitchDialog" @closedialog="closedialog" @logoutensure="logoutensure" />
    <AgreeDialog style="z-index: 2222;" v-if="$store.state.showAgreeDialog"
      :showDialogInCenterPage="showDialogInCenterPage" />
    <Loading v-if="$store.state.showLoading" />
    <Toast v-if="$store.state.showToast" />
    <ServiceCenter v-show="showServiceCenter" :url="url" @servicecenterclose="servicecenterclose"/>
  </div>
</template>

<script>
import Loading from "views/loading/Loading.vue";
import Toast from "views/Normal/Toast.vue";
import { request } from '@/normal/network/request';
import getRequestParams from "@/signParams";
import utils from '@/utils';
import SwitchAccountDialog from 'views/Normal/userCenter/SwitchAccountDialog.vue';
import AgreeDialog from 'views/Normal/login/agreeProtocol/AgreeDialog.vue';
import ServiceCenter from "views/serviceCenter/ServiceCenter.vue";
export default {
  data() {
    return {
      showDialogInCenterPage: true,
      showSwitchDialog: false,
      rootWidth: "100vw",
      rootHeight: "100vh",
      showServiceCenter: false,
      url: "",
      serviceType:""
    }
  },
  components: {
    Loading, Toast, SwitchAccountDialog, AgreeDialog, ServiceCenter
  },
  created: function () {
    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    this.serviceType = utils.getUrlKey("serviceType")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)


    // 获取rid等信息
    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.state.commonParameters;

    // 是否是横屏,修改高度，方便滑動
    if (storeCommomParams['landGame'] === 'true') {
      this.rootHeight = "150vh"
      this.rootWidth = "65vw"
    }

    // 使用公共参数转换成用于请求api需要的参数值形式
    let signParams = getRequestParams({}, storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    let userInfoReq = request({
      url: this.urls.USER_INFO,
      params: {
        data: signParams // 在url后面加上&data=[signParams具体内容]
      },
    });
    let protocolReq = request({
      url: this.urls.GET_PROTOCOL,
      params: {
        data: signParams
      },
    });
    let policyReq = request({
      url: this.urls.GET_POLICY,
      params: {
        data: signParams
      },
    });
    // 获取用户协议和隐私政策的url
    Promise.all([userInfoReq, protocolReq, policyReq]).then(values => {
      // console.log(values);
      // 更新公共参数中的rid和phone，不直接从原始公共参数中传递。是为了避免直接暴露rid
      this.$store.dispatch("networkUpdateRid", { "rid": values[0]["rid"], "phone": values[0]["phone"] })

      this.$store.dispatch('networkUpdateProtocolAndPolicy',
        {
          "protocol": { "title": values[1]['title'], "url": values[1]['url'] },
          "policy": { "title": values[2]['title'], "url": values[2]['url'] }
        }
      )
    })
  },
  methods: {
    userCenterRidClick() {
      var obj = { "content": this.$store.state.rid, "toastMsg": "编号复制成功" };
      this.sendToClient('copyClick?'.concat(JSON.stringify(obj)));
    },
    protocolClick() {
      // 更新本次点击的是哪个，注册协议还是隐私政策
      this.$store.commit("updateClickAgreeType", "protocol");
      // 已经打开对话框，安卓端按返回键应该要拦截不处理，这个是个小优化
      this.sendToClient('openAgreeDialog?')
    },
    privicyClick() {
      // 更新本次点击的是哪个，注册协议还是隐私政策
      this.$store.commit("updateClickAgreeType", "policy");
      // 已经打开对话框，安卓端按返回键应该要拦截不处理，这个是个小优化
      this.sendToClient('openAgreeDialog?')
    },
    servicecenterclose(){
      this.showServiceCenter = false;
      this.url = ""
    },
    clickService() {
      let that = this
      // 通知客户端打开客服
      // this.sendToClient('openService?')
      // 获取当前用户的充值总额   
      let storeCommomParams = this.$store.state.commonParameters;
      // console.log("基本参数 ： ", storeCommomParams);
      let signParams = getRequestParams({}, storeCommomParams);
      this.$store.commit('switchLoading', true)
      if ("qiyu" == this.serviceType) {
        request({
        url: this.urls.PAY_DETAIL,
        params: {
          data: signParams // 在url后面加上&data=[signParams具体内容]
        },
        }).then(res => {
          let userName = storeCommomParams['username']
          let gamename = storeCommomParams['gamename']
          let serverid = storeCommomParams['serverid']
          let rolename = storeCommomParams['rolename']
          let totalpay = res['totalpay']
          let dataStr = JSON.stringify([
              { "key": "real_name", "value": "无" },
              { "key": "mobile_phone", "hidden": true },
              { "key": "email", "value": "无" },
              { "key": "avatar", "label": "头像", "value": "https://ysf.qiyukf.net/operation/080659b993a45dd546fbd71efd5ef000" }, // 访客头像
              { "index": 0, "key": "account", "label": "账号", "value": userName },
              { "index": 1, "key": "gamename", "label": "游戏名", "value": gamename },
              { "index": 2, "key": "serverid", "label": "区服id", "value": serverid },
              { "index": 3, "key": "rolename", "label": "角色名", "value": rolename },
              { "index": 4, "key": "totalpay", "label": "充值总额", "value": totalpay+"" },
            ])
          console.log("数据dataStr == ", dataStr);
          // 使用七鱼客服H5版
          ysf('config', {
            uid: storeCommomParams['rid'],
            name: storeCommomParams['username'],
            mobile: storeCommomParams['phone'],
            data: dataStr,
            success: function () {     // 成功回调
              console.log("成功回调");
              that.url = decodeURIComponent(ysf('url'))
              that.$store.commit('switchLoading', false)
              that.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "正在打开客服..."})
              that.sendToClient('qiyuUrl?'.concat(JSON.stringify({"qiyuUrl": that.url})))

              // window.location.href = that.url 
              // console.log(that.url);
              // that.showServiceCenter = true;
              // ysf('open');
            },
            error: function () {       // 错误回调
              // handle error
              console.log("错误回调");
            }
          });
        })
      }else{
        // QQ客服
        request({
        url: this.urls.CUSTOMER_SERVICE,
        params: {
          data: signParams // 在url后面加上&data=[signParams具体内容]
        },
        }).then(res => {
          that.$store.commit('switchLoading', false)
          that.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "正在打开客服..."})
          console.log("客服接口返回", res);
          that.sendToClient('openQQ?'.concat(JSON.stringify({"qqUrl": "mqqwpa://im/chat?chat_type=wpa&uin=" + res['qq']})))
        })
      }
    },
    closedialog() {
      this.showSwitchDialog = false;
    },
    logoutensure() {
      ysf('logoff');
    },
    pageClose() {
      this.sendToClient('close?')
    },
    clickRealName() {
      if (this.$route.path === "/realName") {
        return;
      }
      this.$router.replace("/realName");
    },
    clickAccountSafe() {
      if (this.$store.state.phone.length > 0) {
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "您已完成账号绑定" });
        return;
      }
      if (this.$route.path === "/accountSafe") {
        return;
      }
      this.$router.replace("/accountSafe");
    },
    clickChangePsw() {
      if (this.$store.state.phone.length > 0) {
        // 显示修改密码
        if (this.$route.path === "/changePsw") {
          this.$store.commit("updateChangePswPageVisible", true);
          return;
        }
        this.$router.replace("/changePsw");
        return;
      }
      this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "请先完成账号绑定" });
      if (this.$route.path === "/accountSafe") {
        return;
      }
      this.$router.replace("/accountSafe");
    },
    clickSwitchAccount() {
      this.showSwitchDialog = true;
    },
  }
}
</script>

<style>
body {
  padding-top: 0%;
  margin: 0%;
}

#normalUserCenterRoot {
  position: relative;
  width: 100vw;
  height: 100vH;
}

#normalUserCenterContainer {
  width: 100%;
  height: 100%;
  background-color: #F5F5F5;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#normalUserCenterTopContent {
  width: 100%;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#normalUserCenterTitleDiv {
  margin: 10px;
  color: white;
  font-size: medium;
}

#normalTopMiddleDiv {
  position: relative;
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#normalTopAccountInfoDiv {
  position: absolute;
  left: 70px;
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#normalAccount {
  width: 100%;
  display: flex;
  align-items: center;
  color: white;
  padding: 3px;
  padding: 3px;
  border-radius: 3px;
}

#normalRid {
  margin-top: 5px;
  border-radius: 3px;
  width: 100%;
  display: flex;
  color: white;
  padding: 3px;
  padding: 3px;
}

#normalFeatureDiv {
  position: absolute;
  top: 130px;
  width: 94%;
  height: 110px;
  display: flex;
  flex-direction: row;
  background-color: white;
  border-radius: 3px;
  z-index: 100;
}

#normalBottomContent {
  /* margin-top: 10px; */
  position: absolute;
  top: 250px;
  width: 94%;
  height: auto;
  /* height: 280px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 200;
}

#normalFeatureContent {
  width: 100%;
  height: auto;
  /* height: 180px; */
  background-color: white;
  border-radius: 3px;
}

#normalProtocolAndPolicyDiv {
  height: 30px;
  width: 100%;
  position: absolute;
  bottom: -30px;
}

input {
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/views/Normal/NormalUserCenter.vue